import { useState } from "react";

/**
 * Hook para gerenciar estado do dialog de visualização de documentos
 * Centraliza lógica comum de abertura/fechamento e URL do documento
 */
export function useDocumentDialog() {
  const [open, setOpen] = useState<boolean>(false);
  const [binaryUrl, setBinaryUrl] = useState<string>("");

  /**
   * Abre o dialog com a URL do documento
   */
  const handleOpen = (url?: string) => {
    if (url) {
      setBinaryUrl(url);
    }
    setOpen(true);
  };

  /**
   * Fecha o dialog e limpa a URL
   */
  const handleClose = () => {
    setBinaryUrl("");
    setOpen(false);
  };

  return {
    open,
    binaryUrl,
    setBinaryUrl,
    handleOpen,
    handleClose,
  };
}
